export default function Banner({banner, children}){
    return <div className={banner}>{children}</div>
}